<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Destino di consegna</span>
</div>

<form class="step-fields" [formGroup]="form" (ngSubmit)="continue()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Riferimento *</mat-label>
    <input matInput formControlName="riferimento" maxlength="35">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Città *</mat-label>
    <input matInput formControlName="citta" maxlength="60">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Provincia *</mat-label>
    <input matInput formControlName="provincia" maxlength="2" autocapitalize="characters" spellcheck="false">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>CAP *</mat-label>
    <input matInput formControlName="cap" inputmode="numeric" maxlength="5">
  </mat-form-field>

  <mat-form-field class="step-field--wide" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Indirizzo *</mat-label>
    <input matInput formControlName="indirizzo" maxlength="35">
  </mat-form-field>
</form>

<span class="title-medium-emphasized">Note riportate in bolla</span>
<ord-new-customer-delivery-notes class="delivery-notes--columns" [nota]="nota" (notaChange)="setNota($event)" />

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!valid || flow.loading()" (click)="continue()">Prosegui</button>
</div>
